module.exports = __webpack_public_path__ + "static/img/map2.73269b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/contactUs/map2.png
// module id = 7lXF
// module chunks = 0